import { tokenAxiosInstance } from '../token.axios.instance'

export const getUserInfo = async () => {
  const axios = tokenAxiosInstance()
  const response = await axios.get('/user-manager-bff/api/users/token')
  return response.data
}
